import {
  INIT_ARTICLES,
  REQUEST_INIT,
  REQUEST_LOADING,
  REQUEST_FAIL,
  REQUEST_SUCCESS,
  GET_ARTICLES_LOADING,
  GET_ARTICLES_SUCCESS,
  GET_ARTICLES_FAIL,
  CLEAN_COPY_ARTICLES_BOX,
  SHOW_COPY_ARTICLES_BOX,
  SET_ARTICLES_LIKE,
  COPY_ARTICLES_LOADING,
  COPY_ARTICLES_SUCCESS,
  COPY_ARTICLES_FAIL,
  SHOW_ARTICLES_SHARE,
  CLEAN_ARTICLES_SHARE,
  GET_ARTICLES_COLLECTIONS_LOADING,
  GET_ARTICLES_COLLECTIONS_SUCCESS,
  GET_ARTICLES_COLLECTIONS_FAIL,
  GET_ARTICLES_POIS_LOADING,
  GET_ARTICLES_POIS_SUCCESS,
  GET_ARTICLES_POIS_FAIL,
} from '../actions/action_types';

export default (
  state = {
    isShowCopyBox: false,
    isShowShareMenu: false,
    copyBox: {
      requestStatus: REQUEST_INIT,
    },
    loading: true,
    id: 0,
    title: '',
    subtitle: '',
    description: '',
    readCount: 0,
    likeCount: 0,
    commentCount: 0,
    copyCount: 0,
    dayCount: 0, // 只有 itinerary 類 getPoiOfTrips 才會用到
    pageview: 0,
    isLike: false,
    areas: [],
    author: {},
    cover: {},
    article: {},
    relation: {},
    url: '',
    publishedAt: 0,
    pois: [],
    startTime: [],
  },
  action,
) => {
  switch (action.type) {
    case INIT_ARTICLES:
      return {
        isShowCopyBox: false,
        isShowShareMenu: false,
        copyBox: {
          requestStatus: REQUEST_INIT,
        },
        loading: true,
        id: 0,
        title: '',
        subtitle: '',
        description: '',
        readCount: 0,
        likeCount: 0,
        commentCount: 0,
        copyCount: 0,
        dayCount: 0, // 只有 itinerary 類 getPoiOfTrips 才會用到
        pageview: 0,
        isLike: false,
        areas: [],
        author: {},
        cover: {},
        article: {},
        relation: {},
        url: '',
        publishedAt: 0,
        pois: [],
        startTime: [],
      };
    case GET_ARTICLES_LOADING:
    case GET_ARTICLES_COLLECTIONS_LOADING:
    case GET_ARTICLES_POIS_LOADING:
      return { ...state, loading: true };
    case GET_ARTICLES_SUCCESS:
      return {
        ...state,
        loading: false,
        ...action.payload,
      };
    case GET_ARTICLES_COLLECTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        pois: action.payload,
      };
    case GET_ARTICLES_POIS_SUCCESS:
      return {
        ...state,
        loading: false,
        pois: action.payload.pois,
        dayCount: action.payload.dayCount,
        startTime: action.payload.startTime,
      };
    case GET_ARTICLES_FAIL:
    case GET_ARTICLES_COLLECTIONS_FAIL:
    case GET_ARTICLES_POIS_FAIL:
      return {
        isShowCopyBox: false,
        isShowShareMenu: false,
        copyBox: {
          requestStatus: REQUEST_INIT,
        },
        id: 0,
        title: '',
        subtitle: '',
        description: '',
        readCount: 0,
        likeCount: 0,
        commentCount: 0,
        copyCount: 0,
        pageview: 0,
        isLike: false,
        areas: [],
        author: {},
        cover: {},
        article: {},
        relation: {},
        url: '',
        publishedAt: 0,
        pois: [],
        startTime: [],
      };
    case CLEAN_COPY_ARTICLES_BOX:
      return {
        ...state,
        isShowCopyBox: false,
        copyBox: {
          requestStatus: REQUEST_INIT,
        },
      };
    case SHOW_COPY_ARTICLES_BOX:
      return {
        ...state,
        isShowCopyBox: true,
        copyBox: {
          requestStatus: REQUEST_INIT,
        },
      };
    case SET_ARTICLES_LIKE:
      return {
        ...state,
        likeCount: action.payload.likeCount,
        isLike: action.payload.isLike,
        common: {
          ...state.common,
          like_counts: action.payload.likeCount,
          is_like: action.payload.isLike,
        },
      };
    case COPY_ARTICLES_LOADING:
      return {
        ...state,
        copyBox: {
          requestStatus: REQUEST_LOADING,
        },
      };
    case COPY_ARTICLES_SUCCESS:
      return {
        ...state,
        copyBox: {
          requestStatus: REQUEST_SUCCESS,
        },
        copyCount: state.copyCount + 1,
        common: {
          ...state.common,
          copy_counts: state.copyCount + 1,
        },
      };
    case COPY_ARTICLES_FAIL:
      return {
        ...state,
        copyBox: {
          requestStatus: REQUEST_FAIL,
        },
      };
    case SHOW_ARTICLES_SHARE:
      return {
        ...state,
        isShowShareMenu: true,
      };
    case CLEAN_ARTICLES_SHARE:
      return {
        ...state,
        isShowShareMenu: false,
      };
    default:
      return state;
  }
};
